import { TextElement } from '@/types'
import { useSettingsStore } from '@/stores/settingsStore'
import { useLabelStore } from '@/stores/labelStore'

interface TextElementPreviewProps {
  element: TextElement
  zoom: number
  mmToPx: number
}

// Map Zebra fonts to approximate web fonts
const fontMap: Record<string, { family: string; sizeMultiplier: number }> = {
  '0': { family: 'Arial, sans-serif', sizeMultiplier: 1 },
  'A': { family: 'monospace', sizeMultiplier: 0.6 },
  'B': { family: 'monospace', sizeMultiplier: 0.7 },
  'C': { family: 'monospace', sizeMultiplier: 0.8 },
  'D': { family: 'monospace', sizeMultiplier: 0.9 },
  'E': { family: 'Arial, sans-serif', sizeMultiplier: 0.8 },
  'F': { family: 'Arial, sans-serif', sizeMultiplier: 1.2 },
  'G': { family: 'Arial, sans-serif', sizeMultiplier: 1.5 },
  'H': { family: 'Arial, sans-serif', sizeMultiplier: 2 },
}

export function TextElementPreview({ element, zoom, mmToPx }: TextElementPreviewProps) {
  const { variableData } = useSettingsStore()
  const { label } = useLabelStore()

  const fontConfig = fontMap[element.font] || fontMap['0']

  // In ZPL, fontSize is the character height in dots
  // Convert dots to mm, then to pixels for display
  const dotsPerMm = label.dpi / 25.4
  const fontSizeInMm = element.fontSize / dotsPerMm
  const fontSize = fontSizeInMm * mmToPx * zoom * fontConfig.sizeMultiplier

  // Replace variables with actual data
  let displayText = element.content
  if (element.isVariable && element.variableName) {
    displayText = variableData[element.variableName] || `{{${element.variableName}}}`
  }

  return (
    <div
      style={{
        fontFamily: fontConfig.family,
        fontSize: `${fontSize}px`,
        whiteSpace: 'nowrap',
        color: element.reverse ? 'white' : 'black',
        lineHeight: 1,
      }}
    >
      {displayText}
    </div>
  )
}
